import { render, staticRenderFns } from "./new-image.vue?vue&type=template&id=2c1b5228&"
import script from "./new-image.vue?vue&type=script&lang=js&"
export * from "./new-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports